import './TransferBankHero.css'
import { Button } from "@mantine/core";
import SectionTitle from "../../../components/SectionTitle/SectionTitle";
import { useNavigate } from "react-router-dom";
import { IconArrowLeft } from "@tabler/icons-react";
import TransferBankCart from '../TransferBankCart/TransferBankCart';

export default function TransferBankHero({isGrand = false}) {
   const navigate = useNavigate()

   const goBack = (event) => {
      event.preventDefault()
      navigate(-1)
   }

   return (
      <div className="transferBankHero-container">
         <SectionTitle isGrand={isGrand} SectionTitle downText="Vamos a terminar tu pago" upText="transferencia bancaria" >

            <Button color={isGrand ? 'var(--color-grand-primary)' : 'var(--color-primary)'} style={{order: -1}} onClick={goBack} variant="outline" mb={20} >
               < IconArrowLeft style={{marginRight: '8px'}} />
               Volver atrás
            </Button>
         
         </SectionTitle>
         <TransferBankCart isGrand={isGrand}/>
      </div>
   )
}
